/* eslint-disable react/no-unused-prop-types */
import styled from 'styled-components';
import * as React from 'react';
import { Flex, FlexCol, FlexAlignCenter } from 'components/primitives/flex';

const wrapper = {
  width: 10,
  height: 8,
  fill: '#72d4ba',
  marginRight: 10,
  marginTop: -2,
};

const Indicator = () => (
  <svg style={wrapper}>
    <circle cx={4} cy={4} r={4} />
  </svg>
);

export interface ListItemEntry {
  text: string;
  isActive: boolean;
  link: string;
  key?: React.Key;
  onClick: () => void;
}

type Props = {
  items: ListItemEntry[];
};

const PanelList = (props: Props) => {
  const { items = [] } = props;

  return (
    <List>
      <ListInside>
        {items.map((item: ListItemEntry) => (
          <PanelListItem
            key={item.key || item.text}
            link={item.link}
            text={item.text}
            onClick={item.onClick}
            isActive={item.isActive}
          />
        ))}
      </ListInside>
    </List>
  );
};

export const PanelListItem = ({ text, isActive, onClick }: ListItemEntry) => (
  <ListItem>
    <Indicator />
    <ListItemText onClick={onClick} className={isActive ? 'Active' : ''}>
      {text}
    </ListItemText>
  </ListItem>
);

export default PanelList;

const List = styled(Flex)`
  width: 100%;
`;

const ListInside = styled(FlexCol)``;

const ListItem = styled(FlexAlignCenter)`
  position: relative;
  &:last-child {
    .ListItemText {
      border-bottom: none;
    }
  }
`;

const ListItemText = styled.button.attrs({ type: 'button' })`
  border-bottom: 1px solid #dbdfe5;
  font-style: normal;
  color: #17233c !important;
  font-weight: 400;
  font-size: 14px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  width: 100%;
  text-align: left;
  &.Active {
    font-weight: 600;
    color: #17233c !important;
  }
`;
